import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import Lummus2ModelInputUnitOpEditDto from './Lummus2ModelInputUnitOpEditDto';
import Lummus2ModelOutputUnitOpEditDto from './Lummus2ModelOutputUnitOpEditDto';
import Lummus2ModelInputAttributeEditDto from './Lummus2ModelInputAttributeEditDto';
import Lummus2ModelAttributeEditDto from './Lummus2ModelAttributeEditDto';
import Lummus2ModelComponentEditDto from './Lummus2ModelComponentEditDto';

export class Lummus2ModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {string} */
		this.state_file = null;
		/** @type {number} */
		this.driverLog = null;
		/** @type {string} */
		this.simulationId = null;
		/** @type {Lummus2ModelComponentEditDto[]} */
		this.components = null;
		/** @type {Lummus2ModelInputUnitOpEditDto[]} */
		this.inputUnitOps = null;
		/** @type {Lummus2ModelOutputUnitOpEditDto[]} */
		this.outputUnitOps = null;
		/** @type {Lummus2ModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {Lummus2ModelAttributeEditDto[]} */
		this.outputAttributes = null;
		/** @type {string} */
		this.subscriptionKey = null;
	}

	/**
	 * @typedef {Object} _Lummus2ModelEditDtoProps
	 * @property {string} state_file
	 * @property {number} driverLog
	 * @property {string} simulationId
	 * @property {Lummus2ModelComponentEditDto[]} components
	 * @property {Lummus2ModelInputUnitOpEditDto[]} inputUnitOps
	 * @property {Lummus2ModelOutputUnitOpEditDto[]} outputUnitOps
	 * @property {Lummus2ModelInputAttributeEditDto[]} inputAttributes
	 * @property {Lummus2ModelAttributeEditDto[]} outputAttributes
	 * @property {string} subscriptionKey
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _Lummus2ModelEditDtoProps} Lummus2ModelEditDtoProps
	 */
	/**
	 *
	 * @param {Lummus2ModelEditDtoProps} props
	 * @returns {Lummus2ModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.state_file = props.state_file;
		this.driverLog = props.driverLog;
		this.simulationId = props.simulationId;
		this.components = props.components !== null ? props.components.map(d => new Lummus2ModelComponentEditDto().setup(d)) : [];
		this.inputUnitOps = props.inputUnitOps !== null ? props.inputUnitOps.map(d => new Lummus2ModelInputUnitOpEditDto().setup(d)) : [];
		this.outputUnitOps = props.outputUnitOps !== null ? props.outputUnitOps.map(d => new Lummus2ModelOutputUnitOpEditDto().setup(d)) : [];
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new Lummus2ModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new Lummus2ModelAttributeEditDto().setup(d)) : [];
		this.subscriptionKey = props.subscriptionKey;
		return this;
	}
}

export default Lummus2ModelEditDto;
